// @flow
import React, { type Node } from 'react';
import { Trans } from 'react-i18next';

import type { Sub } from 'app/components/Tariff/Tariff';

import ToChange from './ToChange';
import ToPay from './ToPay';
import styles from './Nope.scss';


type Props = {
  service?: string,
  text?: string | Node,
  sub?: Sub,
  header?: string,
}

const Nope = ({ service, text, sub, header }: Props) => (
  <div className={styles.root}>
    <div className={styles.sign}>!</div>
    <div>
      <div className={styles.h1}>
        {header
          || <Trans i18nKey="subs:application_not_available">
            {'Приложение недоступно в личном кабинете'}
          </Trans>}
      </div>
      {text || (sub
        ? <ToPay service={service} subId={sub.id} />
        : <ToChange service={service} />)}
    </div>
  </div>
);

export default Nope;
